import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Dropdown, MenuItem } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown } from '@fortawesome/free-solid-svg-icons';

class TermTypesDropdownList extends Component {
	constructor(props) {
		super(props);
		this.handleSelectChange = this.handleSelectChange.bind(this);
	}

	handleSelectChange(selectedId) {
		const { onChange } = this.props;
		if (onChange) {
			onChange(selectedId);
		}
	}

	render() {
		const { name, value, defaultValue, onChange, hideEmptyOption, emptyLabel, data, ...rest } = this.props;

		const selectedId = value;
		const selected = selectedId && data.find(x => x.id === selectedId);

		return <Dropdown>
			<Dropdown.Toggle title={<span>{(selected && selected.name) || emptyLabel} <FontAwesomeIcon icon={faChevronDown} /></span>} noCaret {...rest} />
			<Dropdown.Menu className='dashboard-dropdown-menu'>
				{hideEmptyOption || <MenuItem key={0} eventKey='' onSelect={this.handleSelectChange}><span>{emptyLabel}</span></MenuItem>}
				{data.map(term => {
					return <MenuItem key={term.id} eventKey={term.id} onSelect={this.handleSelectChange}>
						<span>{term.name}</span>
					</MenuItem>;
				})}
			</Dropdown.Menu>
		</Dropdown>;
	}
}

const mapStateToProps = state => {
	const {
		lookups: { termTypes }
	} = state;

	return {
		data: termTypes
	};
};

export default connect(mapStateToProps, {})(TermTypesDropdownList);